import { formatDate, money } from "./api";

export const waPhone = raw => {
  let d = (raw || "").replace(/\D/g, "").replace(/^0+/, "");
  if (d.length === 10) d = `91${d}`;
  return d.length >= 11 ? d : "";
};

export const waLink = (phone, text) => {
  const p = waPhone(phone);
  return p ? `https://wa.me/${p}?text=${encodeURIComponent(text)}` : "";
};

export const paymentMessage = (p, short = "DCEA") => {
  const first = (p.name || "Member").split(" ")[0];
  const until = p.valid_until ? ` It is valid until ${formatDate(p.valid_until)}.` : "";
  const mid = p.member_id ? ` Your Member ID is ${p.member_id}.` : "";
  return `Hello ${first}, your ${short} Hubli–Dharwad membership payment of ${money(p.amount, p.currency)} (${p.plan_label}) has been verified and your membership is now active.${mid}${until} Sign in to your member dashboard: ${window.location.origin}/account\n\n— ${short} Hubli–Dharwad`;
};

export const eventMessage = (reg, event, daysUntil, short = "DCEA") => {
  const first = (reg.name || "there").split(" ")[0];
  const when = daysUntil === 0 ? "is today" : daysUntil === 1 ? "is tomorrow" : `is on ${formatDate(event.date)}`;
  const venue = event.venue ? ` at ${event.venue}` : "";
  return `Hello ${first}, a reminder from ${short} Hubli–Dharwad: "${event.title}" ${when}${venue}. Please show your QR ticket at the door: ${window.location.origin}/ticket/${reg.checkin_code}\n\nSee you there!\n— ${short} Hubli–Dharwad`;
};
